<template>
  <div class="receipts-modal">
    <sweet-modal ref="modal" @close="$emit('close')" blocking>
      <div class="title">화물 입고</div>
      <div class="content">
        <div class="columns">
          <div class="column is-6">
            <admin-form-item label="입고일자">
              <admin-date-picker :data.sync="value.receipt_time"></admin-date-picker>
            </admin-form-item>
            <admin-form-item label="이름">
              <input type="text" class="input-border" v-model="value.name" @input="e => value.name = e.target.value">
            </admin-form-item>
            <admin-form-item label="수취인명">
              <input type="text" class="input-border" v-model="value.receipt_name"
                     @input="e => value.receipt_name = e.target.value">
            </admin-form-item>
            <admin-form-item label="트래킹번호">
              <input type="text" class="input-border" v-model="value.tracking_no"
                     @input="e => value.tracking_no = e.target.value">
            </admin-form-item>
            <admin-form-item label="신청번호">
              <input type="text" class="input-border" v-model="value.reference_no"
                     @input="e => value.reference_no = e.target.value">
            </admin-form-item>
            <admin-form-item label="특이사항">
              <textarea class="input-border" style="height:120px"
                        v-model="value.memo" @input="e => value.memo = e.target.value"></textarea>
            </admin-form-item>
          </div>
          <div class="column is-6">
            <admin-form-item label="실측 무게">
              <input type="number" class="input-border" v-model.number="value.act_weight"
                  ref="act" @focus="$refs.act.select()">
            </admin-form-item>
            <admin-form-item label="가로">
              <input type="number" class="input-border" v-model.number="value.width"
                     ref="width" @focus="$refs.width.select()">
            </admin-form-item>
            <admin-form-item label="세로">
              <input type="number" class="input-border" v-model.number="value.length"
                     ref="length" @focus="$refs.length.select()">
            </admin-form-item>
            <admin-form-item label="높이">
              <input type="number" class="input-border" v-model.number="value.height"
                     ref="height" @focus="$refs.height.select()">
            </admin-form-item>
            <admin-form-item label="부피 무게">
              <input type="number" class="input-border" v-model.number="value.vol_weight"
                     ref="vol" @focus="$refs.vol.select()">
            </admin-form-item>
            <admin-form-item label="청구 무게">
              <input type="number" class="input-border" v-model.number="value.claim_weight"
                    ref="claim" @focus="$refs.claim.select()">
            </admin-form-item>
          </div>
        </div>


        <div class="btn-group-justify-end">
          <button class="button is-primary-light" style="margin-right:20px" @click="print">인쇄</button>
          <button class="button is-light" @click="$refs.modal.close()">취소</button>
          <button class="button is-primary" @click="accept">확인</button>
        </div>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from 'sweet-modal-vue'
  export default {
    name: "ReceiptsModal",
    components: {
      SweetModal
    },
    data() {
      return {
        value: {
          id: 0,
          name: '',
          receipt_name: '',
          tracking_no: '',
          reference_no: '',
          memo: '',
          act_weight: 0.0,
          width: 0.0,
          length: 0.0,
          height: 0.0,
          vol_weight: 0.0,
          claim_weight: 0.0,
          receipt_time: ''
        }
      }
    },
    watch: {
      'value.width'() {
        this.calcVolWeight();
      },
      'value.length'() {
        this.calcVolWeight();
      },
      'value.height'() {
        this.calcVolWeight();
      },
      'value.vol_weight'() {
        this.calcClaimWeight();
      },
      'value.act_weight'() {
        this.calcClaimWeight();
      }
    },
    methods: {
      print(isClose=false) {
        const app = document.getElementById('app');
        const printDiv = document.createElement('div');
        document.body.appendChild(printDiv);
        document.body.style.backgroundColor = 'white';
        printDiv.innerHTML = `<table class="print-table">
<tr>
  <td>이름</td>
  <td>${this.value.name}</td>
</tr>
<tr>
  <td>수취인명</td>
  <td>${this.value.receipt_name}</td>
</tr>
<tr>
  <td>트래킹번호</td>
  <td>${this.value.tracking_no}</td>
</tr>
<tr>
  <td>신청번호</td>
  <td>${this.value.reference_no}</td>
</tr>
<tr>
  <td>입고일자</td>
  <td>${this.datesFormat(this.value.receipt_time, 'date_4')}</td>
</tr>
</table>
<style>
.print-table, th, td {
  border: 1px solid #000;
}
th, td {
  padding: 4px 12px;
  vertical-align: middle !important;
  font-size: 24px !important;
  text-align: center !important;
  font-weight: 900 !important;
}
.print-table {
  width: 130mm;
  height: 90mm;
}
 @media print {
  .print-table {
    width: 130mm;
    height: 90mm;
  }
 }
</style>
`
        app.style.display = 'none';

        setTimeout(() => {
          window.print();
          app.style.display = '';
          document.body.style.backgroundColor = '#e9e9e9';
          document.body.removeChild(printDiv);
          if(isClose) {
            this.$refs.modal.close();
          }
        },500);
      },
      calcVolWeight() {
        this.value.vol_weight = ((this.value.width * this.value.height * this.value.length) / 6000).toFixed(1);
      },
      calcClaimWeight() {
        let claim_weight = this.value.act_weight > this.value.vol_weight ? this.value.act_weight : this.value.vol_weight;
        let fix = claim_weight % 1;
        if(fix > 0 && fix < 0.5) {
          fix = 0.5;
        } else if(fix > 0.5) {
          fix = 1;
        }
        claim_weight = parseInt(claim_weight) + fix;

        this.value.claim_weight = claim_weight;
      },
      init() {
        this.value = {
          id:0,
          name: '',
          receipt_name: '',
          tracking_no: '',
          reference_no: '',
          memo: '',
          act_weight: 0.0,
          width: 0.0,
          length: 0.0,
          height: 0.0,
          vol_weight: 0.0,
          claim_weight: 0.0,
          receipt_time: ''
        };
      },
      open(item) {
        if(item) {
          this.value = this.cloneItem(item);
        } else {
          this.init();
        }
        this.$refs.modal.open();
      },
      valid() {
        let err = '';
        if(this.value.receipt_time === '') {
          err = '입고일자를 입력해주세요.';
        } else if(this.value.name.trim() === '') {
          err = '이름을 입력해주세요.';
        } else if(this.value.receipt_name.trim() === '') {
          err = '수취인을 입력해주세요.';
        } else if(this.value.tracking_no.trim() === '') {
          err = '트래킹번호를 입력해주세요.';
        } else if(this.value.reference_no.trim() === '') {
          err = '신청번호를 입력해주세요.';
        }
        if(err !== '') {
          this.toast(err);
          return false;
        }
        return true;
      },
      accept() {
        if(!this.valid()) {
          return;
        }
        const resMethod = () => {
          this.$store.commit('setLoading', false);
          this.$emit('save', this.value);
          this.print(true);
        };
        this.$store.commit('setLoading', true);
        if(this.value.id === 0) {
          this.$axios.post(`admin/shipagency/${this.$route.path.indexOf('france')>-1 ? 'fr' : 'de'}/receipts`, this.value).then(resMethod).catch(()=>{
            this.$store.commit('setLoading', false);
          });
        } else {
          this.$axios.patch(`admin/shipagency/receipts/${this.value.id}`, this.value).then(resMethod).catch(()=>{
            this.$store.commit('setLoading', false);
          });
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .content
    padding-top 20px
</style>
<style lang="stylus">
  .receipts-modal
    .sweet-modal
      width 800px
      max-height 90vh

    .sweet-modal.is-alert .sweet-content
      padding 20px
</style>
